'use es6';

import { Record } from 'immutable';
import Event from 'MeetingsLib/models/Event';
export default Record({
  event: new Event(),
  postResponse: null
}, 'BookingLifecycleRecord');